export const unwrapList = (response, kind) => {
  const keys = [kind, "data", "items", "results", "rows", "records", "coins"];
  let current = response;
  for (let depth = 0; depth < 5; depth += 1) {
    if (Array.isArray(current)) return current;
    if (!current || typeof current !== "object") return [];
    const nextKey = keys.find((key) => Array.isArray(current[key]) || (current[key] && typeof current[key] === "object"));
    if (!nextKey) return [];
    current = current[nextKey];
  }
  return Array.isArray(current) ? current : [];
};

export const isApiFailure = (response) => response?.success === false || Boolean(response?.error || response?.errors) || /unauthenticated|unauthorized/i.test(response?.message ?? "");
export const apiError = (response) => response?.message ?? response?.error ?? response?.errors?.[0] ?? "Request failed. Please try again.";

const paginationInfo = (response) => {
  const containers = [response, response?.meta, response?.pagination, response?.data, response?.data?.meta, response?.data?.pagination, response?.data?.data, response?.data?.data?.meta];
  const lastPage = containers.map((item) => Number(item?.last_page ?? item?.lastPage ?? item?.total_pages ?? item?.totalPages)).find((value) => Number.isFinite(value) && value > 0);
  const currentPage = containers.map((item) => Number(item?.current_page ?? item?.currentPage ?? item?.page)).find((value) => Number.isFinite(value) && value > 0) ?? 1;
  const total = containers.map((item) => Number(item?.total)).find((value) => Number.isFinite(value) && value >= 0);
  const perPage = containers.map((item) => Number(item?.per_page ?? item?.perPage ?? item?.limit)).find((value) => Number.isFinite(value) && value > 0);
  return { lastPage: lastPage ?? (total && perPage ? Math.ceil(total / perPage) : currentPage), currentPage };
};

export const fetchAllPages = async (getPage, kind, pageSize = 200) => {
  const firstPage = await getPage({ page: 1, per_page: pageSize });
  if (isApiFailure(firstPage)) return { response: firstPage, items: [] };
  const firstItems = unwrapList(firstPage, kind);
  const { lastPage: reportedLastPage, currentPage } = paginationInfo(firstPage);
  const expectedLastPage = reportedLastPage > currentPage ? reportedLastPage : (firstItems.length >= 50 ? 100 : currentPage);
  const collected = [...firstItems];
  const signature = (item) => kind === "assets"
    ? String(item?.id ?? item?.asset_id ?? item?.coin_id ?? `${item?.symbol ?? item?.coin ?? ""}:${item?.name ?? item?.coin_name ?? ""}`)
    : String(item?.id ?? item?.network_id ?? `${item?.coin ?? ""}:${item?.network ?? item?.network_name ?? ""}`);
  const seen = new Set(collected.map(signature));
  let response = firstPage;

  for (let page = currentPage + 1; page <= expectedLastPage; page += 1) {
    const nextResponse = await getPage({ page, per_page: pageSize });
    if (isApiFailure(nextResponse)) return { response: nextResponse, items: collected };
    const nextItems = unwrapList(nextResponse, kind);
    if (!nextItems.length) break;
    const newItems = nextItems.filter((item) => !seen.has(signature(item)));
    if (!newItems.length) break;
    newItems.forEach((item) => seen.add(signature(item)));
    collected.push(...newItems);
    response = nextResponse;
    if (reportedLastPage <= currentPage && nextItems.length < 50) break;
  }
  return { response, items: collected };
};
